var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3722 12.5442H20.0574V15.8742C21.0204 13.959 23.49 12.2382 27.1998 12.2382C34.3116 12.2382 36 16.0506 36 23.0454V36H28.8V24.6384C28.8 20.655 27.837 18.4086 25.3854 18.4086C21.9852 18.4086 20.5722 20.8296 20.5722 24.6366V36H13.3722V12.5442V12.5442ZM1.026 35.694H8.226V12.2382H1.026V35.694V35.694ZM9.2574 4.59C9.25767 5.19349 9.13798 5.79102 8.9053 6.34786C8.67261 6.90469 8.33157 7.40972 7.902 7.8336C7.03152 8.69872 5.85326 9.18298 4.626 9.18C3.4009 9.17918 2.22536 8.69616 1.3536 7.8354C0.925581 7.41008 0.585695 6.90448 0.353419 6.34758C0.121143 5.79067 0.00104244 5.1934 0 4.59C0 3.3714 0.486 2.205 1.3554 1.3446C2.22639 0.482685 3.40243 -0.000538579 4.6278 4.50476e-07C5.8554 4.50476e-07 7.0326 0.4842 7.902 1.3446C8.7696 2.205 9.2574 3.3714 9.2574 4.59Z",
    fill: "#DC6949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5bebe843f9292d0d23ff9d804d6f01be.svg";
export { ForwardRef as ReactComponent };